<template>
    <div class="pdfpage-header">
      <el-row :gutter="20">
        <el-col :span="12">
          <div class="pdfpage-header-logo">
            <img src="@/assets/img/logo-black.png">
          </div>
          <div v-if="partnerlogo != '' && partnerlogo != null && partnerlogo != undefined" class="partner-logo">
            <img class="icon-close-light" src="@/assets/img/close_black.png" />
            <img :src="partnerlogo" />
          </div>
        </el-col>
        <el-col :span="12" class="pdfpage-header-right">
          <h1>Brand Protection Service</h1>
          <h2>{{ brandname }} {{ month }} {{ report }}</h2>
        </el-col>
      </el-row>
    </div>
</template>

<script>
export default {
  name: 'ReportFooter',
  props: ['brandname', 'month', 'report', 'partnerlogo']
}
</script>

<style scoped>
.pdfpage-header-logo{
  float: left;
}
.partner-logo{
  padding-top: 15px;
}
</style>